var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRating(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 12,
    viewBox: "0 0 65 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9596 0L7.78814 3.46616L11.6275 4.1459L8.91825 6.96784L9.46256 10.8541L5.9596 9.132L2.45663 10.8541L3.00095 6.96784L0.291683 4.1459L4.13105 3.46616L5.9596 0Z",
    fill: "#FFCA42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0707 0L20.8992 3.46616L24.7386 4.1459L22.0293 6.96784L22.5736 10.8541L19.0707 9.132L15.5677 10.8541L16.112 6.96784L13.4028 4.1459L17.2421 3.46616L19.0707 0Z",
    fill: "#FFCA42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1818 0L34.0104 3.46616L37.8497 4.1459L35.1405 6.96784L35.6848 10.8541L32.1818 9.132L28.6789 10.8541L29.2232 6.96784L26.5139 4.1459L30.3533 3.46616L32.1818 0Z",
    fill: "#FFCA42"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2929 0L47.1215 3.46616L50.9609 4.1459L48.2516 6.96784L48.7959 10.8541L45.2929 9.132L41.79 10.8541L42.3343 6.96784L39.625 4.1459L43.4644 3.46616L45.2929 0Z",
    fill: "#EEEFF2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4041 0L60.2326 3.46616L64.072 4.1459L61.3627 6.96784L61.907 10.8541L58.4041 9.132L54.9011 10.8541L55.4454 6.96784L52.7361 4.1459L56.5755 3.46616L58.4041 0Z",
    fill: "#EEEFF2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.cf202fbcafd3b367c99c35b6b5251778.svg";
export { ForwardRef as ReactComponent };